import { ReactComponent as TelegramSvg } from '../../assets/icons/telegram.svg';

export const TelegramIcon: SvgIcon = (props) => {
    return <TelegramSvg {...props} />;
};
